import { withHermes } from 'ha/modules/Hermes';
import SupplyLandingPage from '../components/SupplyLandingPage';

export default withHermes(SupplyLandingPage);
